export const NCESID_ALREADY_EXISTS_ERROR_MESSAGE =
  'Organization with NCESID already exists for provided Country Code.'
